var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"search-book-item"},[_c('h3',{staticClass:"book-title"},[_c('router-link',{attrs:{"to":{
        name: _vm.catalogRoutes.catalogInformation,
        params: { catalogId: _vm.item.id }
      }}},[_vm._v(" "+_vm._s(_vm.item.title)+" ")])],1),(_vm.item.chapters.length)?_c('SearchChapter',{attrs:{"data":_vm.item.chapters}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }